import React, { Component } from "react";
import { Login } from "./login/login";
import Button from "../../components/button/button";
import { continuationUrl, interactionUid, oauthRequest } from "../../services/mcpOAuthService";
import styles from "./login/login.scss";
import logo from "../../images/bi-logo-big.png";

export default class McpOAuth extends Component {
  state = { context: null, user: "", password: "", loading: true, error: "", isTrySubmit: false,
    validFields: { user: false, password: false } };

  mounted = false;

  componentDidMount() {
    this.mounted = true;
    this.loadContext();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidUpdate(previous) {
    if (previous.location.pathname !== this.props.location.pathname ||
        previous.location.search !== this.props.location.search) {
      this.uid = null;
      this.setState({ context: null, user: "", password: "", error: "", loading: true,
        isTrySubmit: false, validFields: { user: false, password: false } }, this.loadContext);
    }
  }

  loadContext = async () => {
    let uid;
    try {
      const pathUid = this.props.match && this.props.match.params.uid;
      uid = interactionUid(pathUid ? `?uid=${encodeURIComponent(pathUid)}` : this.props.location.search);
      this.uid = uid;
      const context = await oauthRequest(uid, "context");
      if (context.uid !== uid || !["login", "consent"].includes(context.prompt) ||
          !context.client || typeof context.client.name !== "string" || typeof context.csrf_token !== "string" ||
          (context.permissions && (!Array.isArray(context.permissions.modules) ||
            context.permissions.modules.some(module => typeof module !== "string")))) {
        throw new Error("The authorization request is invalid.");
      }
      if (this.mounted && this.uid === uid) this.setState({ context, loading: false });
    } catch (error) {
      if (this.mounted && (!uid || this.uid === uid)) {
        this.setState({ context: null, loading: false, error: error.message });
      }
    }
  };

  submit = async (action, payload) => {
    if (this.state.loading || !this.state.context) return;
    const uid = this.uid;
    this.setState(previous => ({ loading: true, error: "", password: "",
      validFields: { ...previous.validFields, password: false } }));
    try {
      const result = await oauthRequest(uid, action, {
        ...payload, csrf_token: this.state.context.csrf_token,
      });
      if (!this.mounted || this.uid !== uid) return;
      window.location.assign(continuationUrl(result.redirect_to, window.location.origin));
    } catch (error) {
      if (!this.mounted || this.uid !== uid) return;
      this.setState({ error: error.message });
      await this.loadContext();
    }
  };

  render() {
    const { context, loading, error } = this.state;
    if (context && context.prompt === "login") {
      return <Login {...this.state} oauth={context}
        changeField={(name, value) => this.setState({ [name]: value })}
        changeFieldErrorStatus={(name, value) => this.setState(previous => ({
          validFields: { ...previous.validFields, [name]: value },
        }))}
        trySubmitted={() => this.setState({ isTrySubmit: true })}
        sendForm={({ user, password }) => this.submit("login", { email: user, password })}
      />;
    }
    const permissions = context && context.permissions;
    return <div className={styles.wrapper}><div className={styles.formCont}>
      <div className={styles.logoCont}><img src={logo} alt="Bright Insights" /></div>
      <h1>Authorize MCP access</h1>
      {error && <p role="alert" className={styles.errorBlock}>{error}</p>}
      {loading && <p>Loading authorization request...</p>}
      {context && <div>
        <p>{context.client.name} requests read-only access to your permitted Insights data.</p>
        <p>Account: {context.account && (context.account.email || context.account.user_id)}</p>
        {permissions && <p>Modules at sign-in: {permissions.modules.join(", ")}</p>}
        <p>This does not grant access to other customers or additional modules. Offline access, when requested,
          allows this client to reconnect without signing in until its authorization expires or is revoked.</p>
        <div className={styles.oauthActions}>
          <Button variant="contained" disabled={loading}
            onClick={() => this.submit("consent", { decision: "approve" })}>Approve read-only access</Button>
          <Button disabled={loading}
            onClick={() => this.submit("consent", { decision: "deny" })}>Deny</Button>
        </div>
      </div>}
    </div></div>;
  }
}
